import React, { useCallback, useContext } from "react";
import ReactPlayer from "react-player/vimeo";

import cx from "classnames";

import ViewportContext from "~/common/ViewportContext";
import { dispatchAnalyticsTrack } from "~/lib/segment";

import player from "../images/player.png";
import type { PaneProps } from "./types";

import styles from "../css/Auth.module.css";

export default function VideoPane(_props: PaneProps) {
	const { isLargeMonitor } = useContext(ViewportContext);

	const onWatchVideo = useCallback(() => {
		dispatchAnalyticsTrack("Onboarding Video Started", { feature: "Onboarding" });
	}, []);

	const onVideoEnded = useCallback(() => {
		dispatchAnalyticsTrack("Onboarding Video Ended", { feature: "Onboarding" });
	}, []);

	return (
		<div className={styles.authPane}>
			<div className={styles.videoPane}>
				<div className={styles.shiftedUp} />
				<div className={cx(styles.shiftedCenter, styles.videoWrapper)}>
					<ReactPlayer
						playing
						controls
						light={player}
						width={isLargeMonitor ? "24vw" : "31.2vw"}
						height={isLargeMonitor ? "13.52vw" : "17.57vw"}
						url="https://vimeo.com/349735298"
						className={styles.videoThumbnail}
						onStart={onWatchVideo}
						onEnded={onVideoEnded}
					/>
					<div className={styles.videoDetails}>
						<div className={styles.videoDescription}>Watch how it works</div>
						<div className={styles.videoDuration}>1:53s</div>
					</div>
				</div>
				<div className={styles.shiftedDown} />
			</div>
		</div>
	);
}
